import MuiPagination from "@mui/material/Pagination";

export default function Pagination(props) {
  return <MuiPagination {...props} />;
}
